import attachment from "./attachment.json";
import adminPanel from "./adminPanel.json";
import auth from "./auth.json";
import analytics from "./analytics.json";
import behaviour from "./behaviour.json";
import admin from "./admin.json";
import email from "./email.json";
import call from "./call.json";
import enquiry from "./enquiry.json";
import forms from "./forms.json";
import docs from "./docs.json";
import event from "./event.json";
import chargebee from "./chargebee.json";
import calendar from "./calendar.json";
import action from "./action.json";
import space from "./space.json";
import node from "./node.json";
import error from "./error.json";
import slack from "./slack.json";
import venue from "./venue.json";
import stripe from "./stripe.json";
import graphql from "./graphql.json";
import user from "./user.json";
import mailchimp from "./mailchimp.json";
import networkService from "./networkService.json";
import planService from "./planService.json";
import spaceService from "./spaceService.json";
import subscription from "./subscription.json";
import subscriptionService from "./subscriptionService.json";
import userService from "./userService.json";
import venueService from "./venueService.json";
import photos from "./photos.json";
import sendgrid from "./sendgrid.json";
import intercom from "./intercom.json";
import pricing from "./pricing.json";
import redirect from "./redirect.json";
import viewings from "./viewings.json";
import payments from "./payments.json";
import quote from "./quote.json";

import thread from "./thread.json";
import ruby from "./ruby.json";
import inboxTemplateService from "./inboxTemplateService.json";
import availabilityService from "./availabilityService.json";
import tags from "./tags.json";
import weeklySummary from "./weeklySummary.json";
import lead from "./lead.json";
import sync from "./sync.json";

export default {
  attachment,
  adminPanel,
  auth,
  analytics,
  behaviour,
  admin,
  email,
  call,
  enquiry,
  forms,
  docs,
  event,
  chargebee,
  calendar,
  action,
  space,
  node,
  error,
  slack,
  venue,
  stripe,
  graphql,
  user,
  mailchimp,
  networkService,
  planService,
  spaceService,
  subscription,
  subscriptionService,
  userService,
  venueService,
  photos,
  sendgrid,
  intercom,
  pricing,
  redirect,
  viewings,
  payments,
  thread,
  ruby,
  inboxTemplateService,
  availabilityService,
  quote,
  tags,
  weeklySummary,
  lead,
  sync,
};
